import { Box, Divider, Drawer, IconButton, useMediaQuery } from "@mui/material";
import { Icon } from "components/Icons";
import React from "react";
import { useContactDrawer } from "./useContactDrawer";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { STATICS } from "api/api";
import { useLocation } from "react-router-dom";
import ContactForm from "components/MainFooter/ContactForm";
import { PoweredBy } from "components/PoweredBy/PoweredBy";

  // Function to remove duplicates from contactData based on unique properties
const removeDuplicates = (data) => {
  const seen = new Set();
  return data.filter(item => {
    const identifier = `${item?.Name}|${item?.AddressLine1}|${item?.AddressLine2}|${item?.Phone}|${item?.Email}`;
    return !seen.has(identifier) && seen.add(identifier);
  });
};

const ContactDrawer = () => {
  const { isOpen, toggle, unit } = useContactDrawer();
  const isMobile                 = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const here           = useLocation().pathname;
  const atUnit         = here.includes("unit");
  const atFrontpage    = here.includes("frontpage");
  const atPropertyPage = here.includes("propertypage");

  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? [];
  const contactData  = getFocus(_project, 'ContactProperties')?.[pin]?.[pid] ?? [];
  const sm           = useMediaQuery((theme) => theme.breakpoints.down("sm"));
    // Filter out duplicates
  const uniqueContactData = removeDuplicates(contactData);

  return (
    <Drawer
    hideBackdrop = {true}
    anchor       = {isMobile ? "bottom" : "right"}
    open         = {isOpen}
    onClose      = {() => toggle()}
    PaperProps   = {{ sx: { scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" }, color: f_clr.primaryText, backgroundColor: f_clr.primaryColor, height: { lg: `calc(100% - 162px - ${atUnit || isMobile ? "-90px" : "2px"})` }, top: "70px", justifyContent: "space-between", boxShadow: 'unset', paddingBottom: { xs:"16px", lg: 0 } } }}
    sx           = {{  "&.MuiDrawer-root": { width: 450, top: "70px", right: 0, left: 'unset', bottom: 'unset' } }}
    >
      <Box sx = {{ width: isMobile ? "auto" : 450, position: "relative", pt: 4, pb: 4, px: 3, lineHeight: 1.3 }}>
        <IconButton
          onClick = {toggle}
          sx      = {{
            position: "absolute",
            right   : 16,
            top     : 16,
          }}
        >
          <Icon
            icon     = "close"
            isFaIcon = {true}
            size     = {"lg"}
            sx       = {{
              fontSize: 18,
            }}
          />
        </IconButton>

        <Box sx = {{ mt: 3, lineHeight: 1.5 }}>
        <Box sx = {{ fontWeight: 700, mb: 1 }}>
            {buttonsLabel?.filter(btn => btn?.UILabelProperty === 'Kontaktinformation')[0]?.Label}
          </Box>
          {
            uniqueContactData?.map((item, i) => {
              return (
                <Box sx = {{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }} key = {i}>
                  <Box>
                    <p>{item?.Name}</p>
                    <p>{item?.AddressLine1}</p>
                    <p>{item?.AddressLine2}</p>
                    <p>{item?.Phone}</p>
                    <p>{item?.Email}</p>
                  </Box>
                  <Box sx  = {{ display: 'flex', alignItems: 'center', justifyContent: 'end', width: '150px' }}>
                  <img src = {`${STATICS}${item?.ImageUrl}`} alt = '' />
                 
                  </Box>
                </Box>
              )
            })
          }
        </Box>
        <Divider sx = {{ my: 4, borderColor: `#fff` }} />

        <ContactForm campaignId={'c9cf9f9036f998cc4ff74a29c628cd65'} unit = {unit}>
        <Box         sx   = {{ fontWeight: 700, lineHeight: 1.4, mb: 3 }} isDrawer = {true}>
            {buttonsLabel?.filter(btn => btn?.UILabelProperty === 'SignUpHeading1')[0]?.Label}<br /><br />
            <span style = {{ fontSize: '0.95em', fontWeight: 'normal' }}>{buttonsLabel?.filter(btn => btn.UILabelProperty === 'SignUpHeading2')[0]?.Label}</span>
          </Box>
        </ContactForm>
      </Box>
          <PoweredBy padding = { sm ? "0 0 66px 0" : atUnit || atFrontpage || atPropertyPage ? '16px 0 32px 0px' : "16px 0 16px 0px"} clr = "#FFF"/>
    </Drawer>
  );
};

export default ContactDrawer;
